/* eslint-disable no-unused-vars */
/* eslint-disable react/sort-comp */
/* eslint-disable jsx-a11y/control-has-associated-label */
import _ from 'underscore';
import React from 'react';
import classnames from 'classnames';
import type { AlertProps } from './types';

export type { AlertProps } from './types';

const alertCssClasses = {
  Error: 'alert-danger',
  Warning: 'alert-warning',
  Confirmation: 'alert-success',
  Info: 'alert-info',
};
const defaultIcon = (<span className="alert__icon" aria-hidden="true" />);

let actionArray: HTMLElement[] = [];

export class Alert extends React.Component<AlertProps> {
  static defaultProps: Partial<AlertProps>;

  alertMessageElement: HTMLElement | null = null;

  componentDidMount() {
    this.addActionListeners();
  }

  componentDidUpdate() {
    this.addActionListeners();
  }

  componentWillUnmount() {
    this.removeActionListeners();
  }

  actionButtonClickedHandler = (event: React.MouseEvent<HTMLButtonElement>): void => {
    this.props.onActionClicked((event.target as HTMLElement).innerText);
    if (_.isFunction(this.props.action.callback)) {
      this.props.action.callback();
    }
  };

  actionClickedHandler = (event: MouseEvent): void => {
    const target = event.target as HTMLInputElement;

    const innerText = target.nodeName === 'INPUT'
      ? target.value
      : target.innerText;

    this.props.onActionClicked(innerText);
  };

  addActionListeners(): void {
    // DOM operation only applies for the case when message is string
    if (_.isString(this.props.message)) {
      this.removeActionListeners();
      actionArray = Array.prototype.slice.call(this.alertMessageElement.querySelectorAll('a, button, input[type="button"]'));
      actionArray.forEach(anchor => anchor.addEventListener('click', this.actionClickedHandler));
    }
  }

  removeActionListeners() {
    if (_.isString(this.props.message) && actionArray) {
      actionArray.forEach(anchor => anchor.removeEventListener('click', this.actionClickedHandler));
    }
  }

  render() {
    const {
      level,
      hasIcon,
      customCssClass,
      icon,
      dismissible,
      message,
      action,
      onDismiss,
    } = this.props;

    const cssClass = customCssClass || alertCssClasses[level!];
    const iconSpan = hasIcon && icon;
    const dismissButton = dismissible && (
      <button
        className={classnames('close', 'alert-ignore', 'clickable')}
        type="button"
        tabIndex={0}
        onClick={onDismiss}
      />
    );
    const actionButton = action && (
      <button
        className={classnames('btn', 'btn-default', 'alert__action')}
        type="button"
        onClick={this.actionButtonClickedHandler}
      >
        {action.message}
      </button>
    );
    /* eslint react/no-danger:0 */
    // TODO [Yucongj] Remove dangerouslySetInnerHTML
    const messageContent = _.isString(message)
      ? (
        <span
          className="alert__message"
          dangerouslySetInnerHTML={{ __html: message }}
          ref={(element) => {
            this.alertMessageElement = element;
          }}
        />
      ) : (
        <span className="alert__message">
          {message}
        </span>
      );

    return (
      <div className={classnames('alert', cssClass)} role="alert">
        {iconSpan}
        <div className="alert__content">
          {messageContent}
          {actionButton}
        </div>
        {dismissButton}
      </div>
    );
  }
}

Alert.defaultProps = {
  level: 'Confirmation',
  hasIcon: true,
  customCssClass: '',
  icon: defaultIcon,
  dismissible: true,
  message: undefined,
  action: undefined,
  onDismiss: _.noop,
  onActionClicked: _.noop,
};
